import { createApi } from '@reduxjs/toolkit/query/react';
import baseQueryWithReauth from './base';
import { CreateBankAccountDTO, BankAccountDTO, UpdateBankAccountDTO } from '../../models/bank-account';
import { Response } from '../../models/shared';

const bankAccountApi = createApi({
  reducerPath: 'bankAccountApi',
  baseQuery: baseQueryWithReauth,
  tagTypes: ['bankAccounts'],
  endpoints: (builder) => ({
    getBankAccounts: builder.query<BankAccountDTO[], { businessId: string }>({
      query: ({ businessId }) => ({
        url: `/businesses/${businessId}/bank-accounts`,
        method: 'GET',
      }),
      providesTags: ['bankAccounts'],
      transformResponse: (response: Response<BankAccountDTO[]>) => response.data || [],
    }),
    createBankAccount: builder.mutation<BankAccountDTO, { businessId: string; bankAccountData: CreateBankAccountDTO }>({
      query: ({ businessId, bankAccountData }) => ({
        url: `/businesses/${businessId}/bank-accounts`,
        method: 'POST',
        body: bankAccountData,
      }),
      invalidatesTags: ['bankAccounts'],
    }),
    updateBankAccount: builder.mutation<BankAccountDTO, { businessId: string; bankAccountData: UpdateBankAccountDTO }>({
      query: ({ businessId, bankAccountData }) => ({
        url: `/businesses/${businessId}/bank-accounts`,
        method: 'PUT',
        body: bankAccountData,
      }),
      invalidatesTags: ['bankAccounts'],
    }),
    deleteBankAccount: builder.mutation<BankAccountDTO, { businessId: string; id: string }>({
      query: ({ businessId, id }) => ({
        url: `/businesses/${businessId}/bank-accounts/${id}`,
        method: 'DELETE',
      }),
      invalidatesTags: ['bankAccounts'],
    }),
  }),
});

export const {
  useGetBankAccountsQuery, useCreateBankAccountMutation, useUpdateBankAccountMutation, useDeleteBankAccountMutation,
} = bankAccountApi;
export { bankAccountApi };
